import React, { useEffect, useState } from 'react';

export const Others = ({
  togglePanel,
  formData,
  onFormDataChange,
  onSubmit,
  onBack,
  fetchData,
  loading,
  error
}: any) => {

  const prices = [
    { value: 30, name: '30万円' },
    { value: 40, name: '40万円' },
    { value: 50, name: '50万円' },
    { value: 60, name: '60万円' },
    { value: 70, name: '70万円' },
    { value: 80, name: '80万円' },
    { value: 90, name: '90万円' },
    { value: 100, name: '100万円' },
  ];
  const [workStyles, setWorkStyles] = useState<{ id: number; name: string }[]>([]);
  const [prefectures, setPrefectures] = useState<{ id: number; name: string }[]>([]);

  useEffect(() => {
    const loadWorkStyles = async () => {
      const data = await fetchData('/api/v1/user_working_styles');
      if (data) {
        setWorkStyles(data);
      }
    };

    const loadPrefectures = async () => {
      const data = await fetchData('/api/v1/prefectures');
      if (data) {
        setPrefectures(data);
      }
    };

    loadWorkStyles();
    loadPrefectures();

  }, []);


  const handleCheckboxChange = (id: number) => {
    const updated = formData.workStyles.includes(id)
      ? formData.workStyles.filter((workStyleId: number) => workStyleId !== id)
      : [...formData.workStyles, id];
    onFormDataChange('workStyles', updated);
  };

  return (
    <div className="p-searchPanel">

      <div className="p-searchPanel__header">
        <div className="p-searchPanel__title">検索条件（働き方・地域・希望単価）3/3</div>
        <button
          className="p-searchPanel__closeButton"
          onClick={togglePanel}
        ></button>
      </div>

      {loading && <div>ロード中...</div>}
      {error && <div style={{ color: "red" }}>{error}</div>}

      <div className="p-searchPanel__section">
        <div className="p-searchPanel__section__title">働き方</div>
        <div className="p-searchPanel__section__items">
          {workStyles.map((workStyle) => (
            <div key={workStyle.id}>
              <input
                type="checkbox"
                id={`work_style_${workStyle.id}`}
                className="c-formItem__checkbox"
                checked={formData.workStyles.includes(workStyle.id)}
                onChange={() => handleCheckboxChange(workStyle.id)}
              />
              <label
                htmlFor={`work_style_${workStyle.id}`}
                className="c-formItem__label -hasChedkbox"
              >
                {workStyle.name}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="p-searchPanel__section">
        <div className="p-searchPanel__section__title">地域</div>
        <select
          className="c-formItem__select c-formItem__select--searchPanel"
          value={formData.prefId}
          onChange={(e) => onFormDataChange('prefId', e.target.value)}
        >
          <option value="">選択してください</option>
          {prefectures.map((prefecture) => (
            <option key={prefecture.id} value={prefecture.id}>{prefecture.name}</option>
          ))}
        </select>
      </div>

      <div className="p-searchPanel__section">
        <div className="p-searchPanel__section__title">ご希望単価（単位：万円）</div>
        <div className="p-searchPanel__prices">
          <select
            className="c-formItem__select c-formItem__select--searchPanel"
            value={formData.payMin}
            onChange={(e) => onFormDataChange('payMin', e.target.value)}
          >
            <option value="">選択してください</option>
            {prices.map((price) => (
              <option key={`payMin_${price.value}`} value={price.value}>{price.name}</option>
            ))}
          </select>

          <span>〜</span>

          <select
            className="c-formItem__select c-formItem__select--searchPanel"
            value={formData.payMax}
            onChange={(e) => onFormDataChange('payMax', e.target.value)}
          >
            <option value="">選択してください</option>
            {prices.map((price) => (
              <option key={`payMax_${price.value}`} value={price.value}>{price.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="p-searchPanel__buttons">
        <button
          className="p-searchPanel__actionButton p-searchPanel__actionButton--back"
          onClick={onBack}
        >戻る</button>
        <button
          className="p-searchPanel__searchButton"
          onClick={onSubmit}
        >
          <span>検索</span>
          <img
            src="/asset/img/common/magnifying-glass-white.svg"
            alt="検索アイコン"
            className="p-searchPanel__searchButton__icon"
          />
        </button>
        <div className="p-searchPanel__button"></div>
      </div>
    </div>
  );
};
